import moment from 'moment'

// V-2: the priority is a whole number from 1 to 10. Digits only: `Number` alone would let `7.5`
// (rejected below by the range) and `1e1` (a valid integer) in.
export const parsePriority = (value) => {
  const text = String(value ?? '').trim()
  return /^\d+$/.test(text) ? Number(text) : NaN
}

// A decimal typed with a comma (`5,5`) is the same number as `5.5`.
export const normalizeDecimal = (value) => String(value ?? '').trim().replace(',', '.')

const isEmptyValue = (value) => value === '' || value === null || value === undefined

// The legacy list window checks these in the BROWSER before it saves a row
// (`FabricationOrder.jsx` validator, `SmartMateriaUITable` mandatory columns). The detail follows
// the same logic (PO, 30/09), applied to what this batch touched: an untouched field is not judged.
export const legacyRowErrors = ({ pending, priority, targetDate, orderDate, mandatoryFields, valueOf, numericFields = [] }, t_) => {
  const errors = {}
  if ('priority' in pending) {
    const number = parsePriority(priority)
    if (!Number.isInteger(number) || number < 1 || number > 10) {
      errors.priority = t_('Priority must be a whole number from 1 to 10')
    }
  }
  // V-1: the target date is required, and clearing the text of the picker is a way to empty it.
  if ('targetDate' in pending && isEmptyValue(targetDate)) {
    errors.targetDate = t_('Required')
  } else if ('targetDate' in pending) {
    const order = moment(orderDate, moment.ISO_8601, true)
    const target = moment(targetDate instanceof Date ? targetDate.toISOString() : targetDate, moment.ISO_8601, true)
    if (target.isValid() && order.isValid() && target.isBefore(order)) {
      errors.targetDate = t_('Delivery date must be later than the order date')
    }
  }
  mandatoryFields.forEach((field) => {
    if (field in pending && isEmptyValue(valueOf(field))) {
      errors[field] = t_('Required')
    }
  })
  numericFields.forEach((field) => {
    const value = valueOf(field)
    if (field in pending && !errors[field] && !isEmptyValue(value) && !Number.isFinite(Number(normalizeDecimal(value)))) {
      errors[field] = t_('Value must be a valid number')
    }
  })
  return errors
}
